import * as React from "react";
import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { showMobile } from "helpers/adaptation";

import VideoPosterImg from "assets/images/owlModalIcon.png";
import CloseIcon from "assets/icons/close.svg";
import RectangleIcon from "assets/icons/bidding/mobile/rectangleModal.svg";

import "./SubscriptionPopup.scss";

interface SubscriptionPopupProps {
  onHide: () => void;
  show: boolean;
  modalHeight?: string;
}

const SubscriptionPopup = ({
  show,
  onHide,
  modalHeight = "calc(100vh - 120px)"
}: SubscriptionPopupProps) => {
  const navigate = useNavigate();
  return (
    <Modal
      backdrop={true}
      show={show}
      centered
      className="subscription-modal-wrapper"
      onHide={onHide}>
      <div
        className="subscription-modal-content"
        style={{
          height: modalHeight,
          backgroundColor: "rgb(85 53 155 / 80%)",
          backdropFilter: "blur(10px)",
          WebkitBackdropFilter: "blur(8px)"
        }}>
        {showMobile && (
          <div onClick={onHide} className="modal-dialog-content-rectangle">
            <img src={RectangleIcon} />
          </div>
        )}
        <div className="subscription-modal-header">
          <img src={CloseIcon} alt="Закрити" onClick={onHide} className="close-icon" />
        </div>
        <div className="subscription-modal-body">
          <img src={VideoPosterImg} alt="GoBeB Owl" className="modal-owl-image" />
          <h2 className="modal-title">הגעתם לאזור המיועד למנויים בלבד.</h2>
          <p className="modal-description">
            לקבלת גישה חופשית לכל תכני האתר לחצו על כפתור "רכישת מנוי"
          </p>
          <button onClick={() => navigate("/payment")} className="subscribe-button">
            לרכישת מנוי
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default SubscriptionPopup;

